export default __webpack_public_path__ + "media/images/ongletwhite-leftsmall3-2f2b307f0c580f3054559bbb4f2b3cd7.png";